module.exports = __webpack_public_path__ + "img/icon-check-newslatter.47a9d07b.svg";